import React from "react";
import { Modal, ModalProps } from "@mantine/core";

interface EModalProps extends ModalProps {
  className?: string;
}

export function EModal({
  className = "",
  children,
  ...props
}: EModalProps) {
  return (
    <Modal
      radius="md"
      {...props}
      className={`relative ${className}`}
      styles={{
        header: {
          borderBottom: "1px solid #dee2e6",
          boxShadow: "inset 0 -1px 0 #dee2e6",
          backgroundColor: "#f8f9fa",
        },
      }}
    >
      <div className="mt-6">{children}</div>
    </Modal>
  );
}